import React from 'react';
import styled from 'styled-components';

interface Props {
	className?: string;
	children?: React.ReactNode;
}

const DropdownWrapper = ({ className, children }: Props) => {
	return (
		<div className={className} style={{ position: 'relative' }}>
			{children}
		</div>
	);
};

const _DropdownWrapperExport = styled(DropdownWrapper)``;

export { _DropdownWrapperExport as DropdownWrapper };
